// CheckoutContext.tsx
import React, { createContext, useState, useContext } from "react";
import { FormData, listing_detail_client,guesty_reservation } from "data/types";
import { CLIENT_LISTING_QUOTE_OBJECT, CLIENT_LISTING_ADDONS_OBJECT } from "data/backEndTypes";

interface CheckoutContextProps {
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  context_quote: CLIENT_LISTING_QUOTE_OBJECT | null;
  setContext_Quote: React.Dispatch<React.SetStateAction<CLIENT_LISTING_QUOTE_OBJECT | null>>;
  listing: listing_detail_client | null;
  setListing: React.Dispatch<React.SetStateAction<listing_detail_client | null>>;
  selectedAddons: AddonsType;
  setSelectedAddons: React.Dispatch<React.SetStateAction<AddonsType>>;
  reservation: guesty_reservation | null; 
  setReservation: React.Dispatch<React.SetStateAction<guesty_reservation | null>>; 
}

const defaultFormData: FormData = {
  guest: {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  },
  policy: {
    privacy: {
      dateOfAcceptance: new Date(),
      isAccepted: false,
      version: 1,
    },
    termsAndConditions: {
      isAccepted: false,
      dateOfAcceptance: new Date(),
    },
    marketing: {
      isAccepted: false,
    },
  },
  card: { cardholderName: "", cardNumber: "", expirationYear: "", expirationMonth: "", cvv: "", specialRequest: "" },
};

// Enforce a single type for selectedAddons.
type AddonsType = {
  stepStatus: 2;
  addons: CLIENT_LISTING_ADDONS_OBJECT[];
};

const CheckoutContext = createContext<CheckoutContextProps | undefined>(undefined);

interface CheckoutProviderProps {
  children: React.ReactNode;
}

export const CheckoutProvider: React.FC<CheckoutProviderProps> = ({ children }) => {
  const [formData, setFormData] = useState<FormData>(defaultFormData);
  const [context_quote, setContext_Quote] = useState<CLIENT_LISTING_QUOTE_OBJECT | null>(null);
  const [listing, setListing] = useState<listing_detail_client | null>(null);
  const [selectedAddons, setSelectedAddons] = useState<AddonsType>({ stepStatus: 2, addons: [] });
  const [step, setStep] = useState<number>(1);
  const [reservation, setReservation] = useState<guesty_reservation | null>(null);


  return (
    <CheckoutContext.Provider
      value={{
        step,
        setStep,
        formData,
        setFormData,
        context_quote,
        setContext_Quote,
        listing,
        setListing,
        selectedAddons,
        setSelectedAddons,
        reservation,
        setReservation,
      }}
    >
      {children}
    </CheckoutContext.Provider>
  );
};

export const useCheckout = () => {
  const context = useContext(CheckoutContext);
  if (!context) {
    throw new Error("useCheckout must be used within a CheckoutProvider");
  }
  return context;
};